<template>
  <v-list-tile v-on="$listeners" v-bind="$attrs">
    <v-list-tile-action>
      <v-icon v-if="selected" color="nx-neutral-600">done</v-icon>
    </v-list-tile-action>
    <v-list-tile-content>
      <v-list-tile-title v-text="text"></v-list-tile-title>
    </v-list-tile-content>
  </v-list-tile>
</template>
<script>
export default {
  name: 'nx-dashboard-menu-list-item',
  props: {
    text: String,
    selected: Boolean,
  },
};
</script>
